import {reporter} from 'common/report/error-reporting';
import {selectedPropertiesToColumnNames} from 'common/report/events/utils';
import {InspectorAppState} from 'common/report/events/types';

export const formatDefaultTrackData = (state: Partial<InspectorAppState>) => {
  const {dateRange, entries, selectedProperties, filters, search, limit} = state;
  return {
    Columns: selectedPropertiesToColumnNames(selectedProperties),
    'Date Range': dateRange,
    Entries: entries,
    Events: entries.map((entry) => entry.event.value),
    Filters: filters,
    Search: search,
    Limit: limit,
  };
};

export const enum TrackEvents {
  QueryComplete = `[Inspector] Query complete`,
  ClickRefresh = `[Inspector] Click refresh`,
  ToggleQueryBuilder = `[Inspector] Toggle query builder`,
  LoadMore = `[Inspector] Load More`,
  ViewInInsightsClicked = `[Inspector] Clicked view in insights`,
  ViewInLexiconClicked = `[Inspector] Clicked view in lexicon`,
  ProfileClicked = `[Inspector] Clicked profile icon`,
  SortChanged = `[Inspector] Sort changed`,
  SelectFilterProperties = `[Inspector] Select columns`,

  OpenExportModal = `[export-modal] Open export modal`,
  CreateExport = `[export-modal] Create export`,
  CancelExport = `[export-modal] Cancel export`,

  // expanded-row
  ChangeViewFormat = `[Inspector] Change view format`,
  TogglePropertyKeyFilter = `[Inspector] Toggle property key filter`,

  // profile-sidebar
  SeeUserInProfile = `[Inspector] See User In Profile`,
}

export function track(eventName: TrackEvents, properties = {}): void {
  try {
    mixpanel.track(`[Inspector] ${eventName}`, properties);
  } catch (err) {
    reporter.error(`tracking error`, err);
  }
}
